<template>
  <div>
    <Grid
      :style="css"
      :row-height="30"
      :data-items="gridData"
      :columns="d_columns"
      :filterable="filterable"
      :filter="d_filter"
      :groupable="groupable"
      :group="d_group"
      :expand-field="'expanded'"
      @expandchange="expandChange"
      :scrollable="'virtual'"
      :pageable="d_gridPageable"
      :skip="d_skip"
      :take="d_take"
      :total="d_total"
      :sortable="sortable"
      :sort="d_sort"
      :selected-field="selectedField"
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange"
      :edit-field="'inEdit'"
      @itemchange="itemChange"
      @edit="edit"
      @remove="remove"
      @save="save"
      @cancel="cancel"
      @rowclick="rowClick"
      @cellclick="cellClick"
      @datastatechange="dataStateChange"
      :resizable="true"
      :reorderable="true"
      :cell-render="cellFunction"
      :row-render="rowFunction"
      v-click-outside="closeEdit"
      :column-menu="columnMenu"
    >


      <template v-if="!$scopedSlots.customCommandCell" v-slot:InlineCommands="{props, listeners, methods}">
        <inline-commands v-bind="{ ...props, idField: id, editOperations: editOperations}" v-on="listeners" />
      </template>
      <template v-if="!$scopedSlots.customCommandCell" v-slot:BasicIncellCommands="{props, listeners, methods}">
        <basic-incell-commands v-bind="{ ...props, idField: id, editOperations: editOperations}" v-on="listeners" />
      </template>

      <grid-toolbar>
        <slot
          name="header"
          v-bind:props="{editMode, d_filter}"
          v-bind:methods="{load, closeEdit, insert, print,cancelChanges, hasItemsInEdit, save, exportExcel, exportExcelAdvance, clearAllFilters, selectedItems}"
        ></slot>
      </grid-toolbar>

      <!-- Passing all the scoped slot -->
      <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data" v-bind:methods="{handleFilterChange}"></slot>
      </template>

      <!-- Passing all the slot does not work since we pass all scopped slots -->
      <!-- <template v-for="(index, name) in $slots" v-slot:[name]>
        <slot :name="name" />
      </template>-->
    </Grid>

    <slot
      name="externalForm"
      v-bind:props="{itemInEdit}"
      v-bind:methods="{save, cancel}"
    ></slot>
    <slot
      name="externalForm2"
      v-bind:props="{itemInEdit}"
      v-bind:methods="{save, cancel}"
    ></slot>
    <div v-if="loading" class="balance-loading">
      <div class="k-loading-mask customPosition">
        <span class="k-loading-text"></span>
        <div class="k-loading-image" />
        <div class="k-loading-color" />
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   Grid,
//   GridColumnMenuSort,
//   GridColumnMenuFilter,
// } from "@progress/kendo-vue-grid";
import {
  filterBy,
  CompositeFilterDescriptor,
  process,
} from "@progress/kendo-data-query";
import Vue from "vue";
import InlineCommands from "./inline-commands";
import BasicIncellCommands from "./basic-incell-commands";
import allSettled from "promise.allsettled";
import { saveExcel } from "@progress/kendo-vue-excel-export";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export default {
  props: {
    css: Object,
    columns: Array,
    datasource: Object,
    autoload: Boolean,
    columnMenu: Boolean,
    excelFileName: String,
    filterable: Boolean,
    filter: Object,
    groupable: Boolean,
    group: Array,
    pageable: [Object, Boolean],
    skip: Number,
    take: Number,
    total: Number,
    sortable: Boolean,
    sort: Array,
    editMode: {
      type: String,
      required: true,
      validator: function (value) {
        // The value must match one of these strings
        return ["basic", "inline", "incell", "external"].indexOf(value) !== -1;
      },
    },
    editOperations: {
      type: Object,
      default: {
        add: true,
        edit: true,
        remove: true,
        print:true
      },
    },
    actionWidth: {
      type: String,
      default: 'auto',
    },
    selectable: Boolean,
    actionsHeaderClassName: String,
    selectableHeaderClassName: String,
  },
  components: {
    InlineCommands,
    BasicIncellCommands,
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  data: function () {
    return {
      id: this.datasource.idField || "id",
      items: [], // Store item list
      gridData: [], // Store item list after process
      d_filter: this.filter || null,
      d_group: this.group || [],
      d_gridPageable: this.pageable,
      // d_gridPageable: {
      //     pageSizes: true, // Boolean or Array<number>—Shows a menu for selecting the page size.
      //     previousNext: // Boolean—Toggles the Previous and Next buttons.
      //     buttonCount: // Number—Sets the maximum numeric buttons count before the buttons are collapsed.
      //     info: // Boolean—Toggles the information about the current page and the total number of records.
      //     type: // PagerType—Accepts the numeric (buttons with numbers) and input (input for typing the page number) values.
      // },
      d_skip: this.skip || 0, // Defines the number of records that will be skipped by the pager (see example). Required by the paging functionality.
      d_take: this.take || 20, // Alias of the pageSize property. If take is set, pageSize will be ignored. (Defines the page size that is used by the Grid pager)
      d_sort: this.sort || [],
      d_total: this.total || 0, // (DON) this is the total count of items (used to display the count on footer by the pagination), d-grid will set this automatically after load

      selectedField: "dselected",

      // edit
      editID: null,
      editField: undefined,
      itemInEdit: null, // for external form
      batch: [],

      loading: false,
    };
  },
  created() {
    if (this.autoload) {
      this.load(false);
    }
  },
  computed: {
    areAllSelected() {
      return this.gridData.findIndex((item) => item.dselected === false) === -1;
    },
    selectedItems() {
      return this.items.filter(d => d.dselected);
    },
    d_columns() {
      const cols = [
        ...this.columns,
      ];

      if (this.selectable) {
        cols.unshift({
          field: "dselected",
          width: "50px",
          headerSelectionValue: this.areAllSelected,
          filterable: false,
          headerClassName: this.selectableHeaderClassName
        })
      }

      if(this.$scopedSlots.customCommandCell) {
        cols.push({
          cell: "customCommandCell",
          filterable: false,
          columnMenu: false,
          headerClassName: this.actionsHeaderClassName,
          width: this.actionWidth,
          locked: true,
        });
      } else {
        if (this.editOperations.edit || this.editOperations.remove || this.editOperations.print) {
          if (this.editMode === "inline" || this.editMode == "external") {
            cols.push({
              cell: "InlineCommands",
              filterable: false,
              columnMenu: false,
              headerClassName: this.actionsHeaderClassName,
              width: this.actionWidth,
            });
          }
        }

        if (this.editOperations.remove) {
          if (this.editMode === "incell" || this.editMode === "basic") {
            cols.push({
              cell: "BasicIncellCommands",
              filterable: false,
              width: "90px",
              columnMenu: false,
              headerClassName: this.actionsHeaderClassName,
              width: this.actionWidth,
            });
          }
        }
      }


      return cols;
    },
    hasItemsInEdit() {
      if (this.editMode === "inline") {
        return this.gridData.filter((p) => p.inEdit).length > 0;
      } else {
        if (this.batch.added && this.batch.updated && this.batch.removed) {
          return (
            this.batch.added.length ||
            this.batch.updated.length ||
            this.batch.removed.length
          );
        }

        return false;
      }
    },
  },
  watch: {
    items: {
      deep: true,
      handler() {
        // we freeze the object so vuejs won't be able to observe on it, this is to reduce the memory consumption
        this.batch = Object.freeze(this.datasource.getDiff(this.items));
      },
    },
  },
  methods: {
    clearAllFilters() {
      this.d_filter = null;
      this.getData();
    },
    handleFilterChange: function(filter){
      // this only for relationship column menu
      this.d_filter = filter;
      this.getData();
    },
    exportExcel() {
      if (this.excelFileName) {
        if(this.excelFileName == "mouvements-workers.xlsx" || this.excelFileName == "security.xlsx"){
          this.columns.push({
            field: "Signature",
            title: "Signature",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
          })
        }

        saveExcel({
          data: this.items,
          fileName: this.excelFileName,
          columns: this.columns.filter((c) => c.exportExcel),
        });

        if(this.excelFileName == "mouvements-workers.xlsx" || this.excelFileName == "security.xlsx"){
          this.columns.pop()
        }
      }
    },
    exportExcelAdvance(){
      let newColumns = [
          {
            field: "Period",
            title: "Période",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
            width: "110px",
            cell: this.cellCustomised,


          },
          {
            field: "NomEmploye",
            title: "Nom de l'employé",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
            width: "110px",
          },
          {
            field: "Poste",
            title: "Poste",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
            width: "110px",
          },
          {
            field: "Matricule",
            title: "Matricule",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
            width: "110px",
          },
          {
            field: "Sorti",
            title: "Debit ( Payé )",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
            width: "110px",
          },
          {
            field: "Remarque",
            title: "Remarque",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
            width: "110px",
          },
        {
            field: "Signature",
            title: "Signature",
            exportExcel: true,
            headerClassName: "bg-dark text-light",
            width: "110px",

          }
        ]

        saveExcel({
          data: this.items,
          fileName: "2-"+ this.excelFileName,
          columns: newColumns,
        });
    },


    getData: function () {
      this.gridData = process(this.items, {
        filter: this.d_filter,
        take: this.d_take,
        skip: this.d_skip,
        group: this.d_group,
        sort: this.d_sort,
      }).data.map((item) =>
        Object.assign({ inEdit: item[this.id] === this.editID }, item)
      );

      this.d_total = process(this.items, {
        filter: this.filter,
      }).total;
    },
    createAppState: function (dataState) {
      this.d_filter = dataState.filter;
      this.d_take = dataState.take;
      this.d_skip = dataState.skip;
      this.d_group = dataState.group;
      this.d_sort = dataState.sort;
      this.getData();
    },
    dataStateChange: function (event) {
      this.createAppState(event.data);
    },
    expandChange: function (event) {
      Vue.set(event.dataItem, event.target.$props.expandField, event.value);
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      Vue.set(
        this,
        "items",
        this.items.map((item) => {
          return { ...item, dselected: checked };
        })
      );
      this.getData();
    },
    onSelectionChange(event) {
      this.items.find((i) => i[this.id] === event.dataItem[this.id])[
        this.selectedField
      ] = !event.dataItem[this.selectedField];
      Vue.set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
      this.getData();
    },
    load(online, params) {
      this.loading = true;
      this.datasource
        .read(online, params)
        .then((data) => {
          this.items = data.map((item) => {
            return { ...item, dselected: false };
          });
          this.getData();
        })
        .finally(() => (this.loading = false));
    },
    itemChange: function (e) {
      const temp = e.field.split('.')
      const field = temp[0]

      if (this.editMode === "basic" || this.editMode === "incell") {
        const data = this.items.slice();
        const index = data.findIndex((d) => d[this.id] === e.dataItem[this.id]);
        data[index] = { ...data[index], [field]: e.value };
        if (temp[1] && e.event.relation) {
          // if relationship exist (WE SHOULD HANDLE INLINE TOO)
          data[index] = { ...data[index], [e.event.relation.relationKey]: e.event.relation.value };
        }
        this.items = data;
        Vue.set(e.dataItem, field, e.value);
        this.getData();
      }
      if (this.editMode === "inline") {
        if (e.dataItem[this.id]) {
          let index = this.gridData.findIndex(
            (p) => p[this.id] === e.dataItem[this.id]
          );
          let updated = Object.assign({}, this.gridData[index], {
            [field]: e.value,
          });
          this.gridData.splice(index, 1, updated);
        } else {
          Vue.set(e.dataItem, field, e.value);
        }
      }
    },
    cancelChanges() {
      if (confirm("Voulez-vous annuler les modifications?")) {
        this.load(false);
      }
    },
    insert() {
      if (this.editMode === "basic" || this.editMode === "incell") {
        this.editID = null;
        const newRecord = {};
        newRecord[this.id] = this.nextId();
        const data = this.items.slice();
        data.unshift(newRecord);
        this.items = data;
        if (this.editMode === "basic") {
          this.editID = newRecord[this.id];
        }
        this.getData();
      }
      if (this.editMode === "inline") {
        const dataItem = { inEdit: true };
        const newRecord = this.gridData.slice();
        this.gridData.splice(0, 0, dataItem);
      }

      if (this.editMode == "external")
      {
        this.itemInEdit = {}
      }
    },
    edit: function (e) {
      if (this.editMode === "inline") {
        let index = this.gridData.findIndex(
          (p) => p[this.id] === e.dataItem[this.id]
        );
        let updated = Object.assign({}, this.gridData[index], { inEdit: true });
        this.gridData.splice(index, 1, updated);
      }

      if (this.editMode == "external") {
        this.$nextTick(() => {
          this.itemInEdit = { ...e.dataItem };
        })
      }
    },
    save: function (e, params) {
      if (this.editMode === "inline") {
        let index = this.gridData.findIndex(
          (p) => p[this.id] === e.dataItem[this.id]
        );
        let item = this.gridData[index];
        let updated = Object.assign(this.update(this.gridData.slice(), item), {
          inEdit: undefined,
        });
        this.gridData.splice(index, 1, updated);
        let updateDataIndex = this.items.findIndex(
          (p) => p[this.id] === e.dataItem[this.id]
        );
        this.items.splice(updateDataIndex, 1, updated);
      } else if(this.editMode === "external") {
        if(this.itemInEdit[this.id]) {
          this.loading = true
          this.datasource
            .update(this.itemInEdit, params)
            .then((resp) => {
              let index = this.items.findIndex(
                (i) => i[this.id] == resp[this.id]
              );
              this.items[index] = resp;
              this.getData();
            })
            .catch((err) => console.log(err))
            .finally(() => {
              this.loading = false
              this.itemInEdit = undefined
            })
        } else {
          this.loading = true
          this.datasource
            .save(this.itemInEdit, params)
            .then((resp) => {
              const data = this.items.slice();
              data.unshift(resp);
              this.items = data;
              this.getData();
            })
            .catch((err) => console.log(err))
            .finally(() => {
              this.loading = false
              this.itemInEdit = undefined
            })
        }
      } else {
        this.editID = null;
        this.loading = true;
        const batch = [];
        this.batch.added.forEach((added) => {
          batch.push(
            new Promise((resolve, reject) => {
              this.datasource
                .save(added, params)
                .then((resp) =>
                  resolve({
                    data: resp,
                    type: "create",
                    fakeId: added[this.id],
                  })
                )
                .catch((err) => reject(err));
            })
          );
        });
        this.batch.updated.forEach((updated) => {
          batch.push(
            new Promise((resolve, reject) => {
              this.datasource
                .update(updated, params)
                .then((resp) => resolve({ data: resp, type: "update" }))
                .catch((err) => reject(err));
            })
          );
        });
        this.batch.removed.forEach((removed) => {
          batch.push(
            new Promise((resolve, reject) => {
              this.datasource
                .remove(removed, params)
                .then((resp) => resolve(resp))
                .catch((err) => reject(err));
            })
          );
        });

        allSettled(batch).then((results) => {
          results.forEach((result) => {
            if (result.status == "rejected") {
              console.log(result.reason.response);
            } else {
              if (result.value.type == "update") {
                const item = result.value.data;
                let index = this.items.findIndex(
                  (i) => i[this.id] == item[this.id]
                );
                this.items[index] = item;
              }

              if (result.value.type == "create") {
                const item = result.value.data;
                let index = this.items.findIndex(
                  (i) => i[this.id] == result.value.fakeId
                );
                this.items[index] = item;
              }
            }
          });

          this.items = this.items.map((i) => i);
          this.loading = false;
        });
        // saving batch (incell and basic)
      }
    },
    update(data, item, remove) {
      // this is to update an array
      let updated;
      let index = data.findIndex(
        (p) => item[this.id] && p[this.id] === item[this.id]
      );
      if (index >= 0) {
        updated = Object.assign({}, item);
        data[index] = updated;
      } else {
        updated = { ...item };
        updated[this.id] = this.nextId();
        data.unshift(updated);
        index = 0;
      }

      if (remove) {
        data = data.splice(index, 1);
      }
      return data[index];
    },
    print(e){
      alert("print")
      if (this.editMode === "inline") {
        let index = this.gridData.findIndex(
          (p) => p[this.id] === e.dataItem[this.id]
        );
        let updated = Object.assign({}, this.gridData[index], { inEdit: true });
        this.gridData.splice(index, 1, updated);
      }

      if (this.editMode == "external") {
        this.$nextTick(() => {
          this.itemInEdit = { ...e.dataItem };
        })
      }
    },
    cancel(e) {
      if (this.editMode === "inline") {
        if (e.dataItem[this.id]) {
          let index = this.gridData.findIndex(
            (p) => p[this.id] === e.dataItem[this.id]
          );
          let itemsIndex = this.items.findIndex(
            (p) => p[this.id] === e.dataItem[this.id]
          );
          let updated = Object.assign(this.items[itemsIndex], {
            inEdit: undefined,
          });
          this.gridData.splice(index, 1, updated);
        } else {
          let index = this.gridData.findIndex(
            (p) => JSON.stringify(e.dataItem) === JSON.stringify(p)
          );

          this.gridData.splice(index, 1);
        }
      }

      if (this.editMode == "external") {
        this.itemInEdit = undefined;
      }
    },
    remove(e) {
      if (confirm("Do you want to remove this item ?")) {
        if (this.editMode === "inline" || this.editMode === "external") {
          this.loading = true
          this.datasource
            .remove(e.dataItem)
            .then((resp) => {
              e.dataItem.inEdit = undefined;
              this.update(this.gridData, e.dataItem, true);
              this.update(this.items, e.dataItem, true);
              this.gridData = this.gridData.slice();
            })
            .catch((err) => console.log(err))
            .finally(() => this.loading = false)
        }
        if (this.editMode === "basic" || this.editMode === "incell") {
          let index = this.items.findIndex(
            (p) => p[this.id] === e.dataItem[this.id]
          );
          let data = this.items.slice();
          data.splice(index, 1);
          this.items = data;
          this.getData();
        }
      }
    },
    nextId() {
      // let id = 1;
      // this.items.forEach((p) => {
      //   if (p[this.id]) {
      //     id = Math.max(p[this.id] + 1, id);
      //   }
      // });

      return makeid(5);
    },
    rowClick: function (e) {
      if (this.editMode === "basic") {
        this.editID = e.dataItem[this.id];

        Vue.set(e.dataItem, "inEdit", true);
        this.getData();
      }
    },
    closeEdit(e) {
      if (this.editMode === "basic") {
        if (e.target === e.currentTarget) {
          this.editID = null;
        }
        this.getData();
      }

      if (this.editMode === "incell") {
        this.exitEdit();
      }
    },
    cellClick: function (e) {
      if (this.editMode === "incell") {
        if (e.dataItem.inEdit && e.field === this.editField) {
          return;
        }
        this.exitEdit(e.dataItem);
        this.editField = e.field;
        Vue.set(e.dataItem, "inEdit", e.field);
      }
    },
    exitEdit: function (dataItem = null) {
      if (dataItem && dataItem.inEdit) {
        return;
      }
      this.gridData.forEach((d) => {
        if (d.inEdit) {
          Vue.set(d, "inEdit", undefined);
        }
      });
      this.editField = undefined;
    },
    cellFunction: function (h, tdElement, props, listeners) {
      if (this.editMode === "incell") {
        this.$nextTick(() => {
          tdElement.elm.tabIndex = 0;
          if (tdElement.context.field !== "dselected") {
            // this is a workaroud to autofocus input inside tdElement, we have to ommit select field
            let $field = tdElement.elm.firstElementChild;
            if ($field) $field.focus();
          }
        });
      }

      let setEdit = (e) => {
        let event = {
          dataItem: props.dataItem,
          field: props.field,
          tdElement: tdElement,
        };
        this.cellClick(event);
      };

      if (tdElement.data.on) {
        tdElement.data.on.focus = setEdit;
      } else {
        tdElement.data.on = {
          focus: setEdit,
        };
      }
      return tdElement;
    },
    rowFunction: function (h, trElement, defaultSlots, props, listeners) {
      if (this.editMode === "basic") {
        this.$nextTick(() => {
          trElement.elm.tabIndex = 0;

          // clean
          trElement.elm.classList.remove("table-warning");
          trElement.elm.classList.remove("table-success");
          trElement.elm.classList.remove("table-danger");
          if (this.batch) {
            if (
              this.batch.added.findIndex(
                (d) => d[this.id] === trElement.context.dataItem[this.id]
              ) >= 0
            ) {
              trElement.elm.classList.add("table-success");
            }
            // if (this.batch.removed.findIndex(d => d[this.id] === trElement.context.dataItem[this.id]) >= 0) {
            //   trElement.elm.classList.add("table-secondary")
            // }
            // if (this.batch.same.findIndex(d => d[this.id] === trElement.context.dataItem[this.id]) >= 0) {
            // }
            if (
              this.batch.updated.findIndex(
                (d) => d[this.id] === trElement.context.dataItem[this.id]
              ) >= 0
            ) {
              trElement.elm.classList.add("table-warning");
            }
          }
        });
      }
      let setEdit = (e) => {
        let event = {
          dataItem: props.dataItem,
        };
        this.rowClick(event);
      };
      if (trElement.data.on) {
        trElement.data.on.focus = setEdit;
      } else {
        trElement.data.on = {
          focus: setEdit,
        };
      }
      return trElement;
    },
  },
};
</script>
